// extracted by mini-css-extract-plugin
module.exports = {"remote-svg":"RemoteSvg_remote-svg__svYl7"};